import { FC } from 'react'
import Typography from '@/ui/components/typography'
import { useCustomTheme } from '@/core/theme'
import {
    ConnectionStatusContainer,
    PartialConnectionStatusContainer,
} from './ConnectionStatus.styles'
import { ConnectionStatusProps } from './ConnectionStatus.types'
import ActiveIcon from '@/assets/images/active-icon.svg?react'
import { ActivationButton } from '@/ui/components/ActivationButton'
import CircleIndicator from '@/ui/components/circle-indicator'
import WarningIcon from '@/assets/images/exclamation-mark-orange.svg?react'
import { IntegrationsStore } from '@/core/store/Integrations/integrations.store'

const ConnectionStatus: FC<ConnectionStatusProps> = ({
    id,
    isActive,
    hasConnectionError,
    onClick,
    isLoading,
}) => {
    const theme = useCustomTheme()

    const numberOfFdEnabledSecurityServices =
        IntegrationsStore.getNumberOfFdEnabledSecurityServices()
    const isFDBroken = IntegrationsStore.isFDBroken()

    const getErrorStatus = () => {
        if (id === 'cloud-app-security-feature') {
            return {
                text: 'Connection Lost',
                testId: `overview-card-${id}-status-broken`,
            }
        } else {
            if (isFDBroken) {
                return {
                    text: 'Connection Lost',
                    testId: `overview-card-${id}-status-broken`,
                }
            }
            if (numberOfFdEnabledSecurityServices > 0) {
                return {
                    text: 'Partially activated',
                    testId: `overview-card-${id}-status-partially-activated`,
                }
            }
            return {
                text: 'Disabled',
                testId: `overview-card-${id}-status-disabled`,
            }
        }
    }

    if (isLoading) {
        return (
            <ConnectionStatusContainer
                data-testid={`overview-card-${id}-status-loading`}
            >
                <CircleIndicator size={15} width={2} loading={true} />
                <Typography
                    variant="xs-regular"
                    color={theme.colors.greys[700]}
                >
                    Connecting...
                </Typography>
            </ConnectionStatusContainer>
        )
    }
    // has broken integrations or security services are disabled
    if (hasConnectionError) {
        const { text, testId } = getErrorStatus()

        return (
            <PartialConnectionStatusContainer
                data-testid={testId}
                onClick={onClick}
            >
                <WarningIcon width={16} height={16} />
                <Typography
                    variant="xs-regular"
                    color={theme.colors.greys[900]}
                >
                    {text}
                </Typography>
            </PartialConnectionStatusContainer>
        )
    }

    if (isActive) {
        return (
            <ConnectionStatusContainer
                data-testid={`overview-card-${id}-status-active`}
            >
                <ActiveIcon />
                <Typography
                    variant="xs-regular"
                    color={theme.colors.greys[900]}
                >
                    Activated
                </Typography>
            </ConnectionStatusContainer>
        )
    }

    return <ActivationButton onClick={onClick} text="Activate" id={id} />
}

export default ConnectionStatus
